/**
 * Progressive enhancement only: Shopify's native form handles language routing.
 * Scoped listeners survive Theme Editor replacement and clean up on disconnect.
 */
if (!customElements.get('language-switcher')) {
  customElements.define('language-switcher', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      const details = this.querySelector('details');
      const toggle = this.querySelector('summary');
      const options = [...this.querySelectorAll('[name="language_code"]')];

      const close = () => { details.open = false; };

      // The neighboring currency control stops click propagation; pointerdown
      // still closes this panel before that control opens its own dropdown.
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) close();
      }, { signal });

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          toggle.focus();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();
          details.open = true;
          const index = options.indexOf(document.activeElement);
          const next = index < 0
            ? (event.key === 'ArrowDown' ? 0 : options.length - 1)
            : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[next]?.focus();
        }
      }, { signal });

      this.addEventListener('submit', (event) => {
        if (event.submitter?.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          close();
          toggle.focus();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }
  });
}
